import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditSharedListPayload } from '@app-store/slices/sharedLists/edit'

interface TaskAction extends Action {
    payload: IEditSharedListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sharedLists.edit

function* editSharedListSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.patch(`/companies/shared-lists/${payload.sharedListId}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editSharedListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editSharedListSagaTask)
}

export default editSharedListSaga
